export default "__VITE_ASSET__6b9c0f1b__"